// expandable items
$('.expandable-items .item .item__toggle').on('click', function (e) {
    e.preventDefault();

    let $toggle = $(this),
        $item = $toggle.closest('.item'),
        toggledClass = 'item--toggled',
        $content = $toggle.siblings('.item__content');

    if ($item.hasClass(toggledClass)) {
        // close item
        $item.removeClass(toggledClass);
        $content.stop().slideUp(300);
    } else {
        // close other items
        // $item.siblings('.item--toggled').removeClass(toggledClass).find('.item__content').stop().slideUp(300);

        // open item
        $item.addClass(toggledClass);
        $content.stop().slideDown(300);
    }
});

// expand pre-toggled expandable items on pageload
$('.expandable-items .item.item--toggled').each(function () {
    let $content = $(this).find('.item__content');

    $content.show();
});
